
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Spinner from 'vue-simple-spinner'
import {
    faStar,
    faCheck,
    faChevronDown,
} from '@fortawesome/free-solid-svg-icons'

type VariantType = 'primary' | 'secondary' | 'ghost'
type fontAwesomeType = 'faStar' | 'faCheck' | 'faChevronDown'

const fontAwesomeSources = {
    faStar,
    faCheck,
    faChevronDown,
}

const spinnerColors = {
    primary: '#FFFFFF',
    secondary: '#2E5BFF',
    ghost: '#2F384C',
}

@Component<BaseButton>({
    components: {
        Spinner,
        FontAwesomeIcon,
    },
})
export default class BaseButton extends Vue {
    @Prop({ type: Boolean, required: false, default: false })
    public readonly full!: boolean
    @Prop({ type: Boolean, required: false, default: false })
    public readonly disabled!: boolean
    @Prop({ type: Boolean, required: false, default: false })
    public readonly loading!: boolean
    @Prop({ type: String, required: false, default: 'primary' })
    public readonly variant!: VariantType
    @Prop({ type: String, required: false, default: '' })
    public readonly fontAwesome!: fontAwesomeType

    public fontAwesomeSources = fontAwesomeSources
    public spinnerColors = spinnerColors

    public handleClick(event: Event) {
        this.$emit('click', event)
    }
}
